define('home/views/UnreadCountView',[
    'backbone-marionette',
    'home/templates/unreadCount',
], function (
    Marionette,
    unreadCountTemplate
) {
    'use strict';

    var parent = Marionette.ItemView;
    var parentProto = parent.prototype;


    return parent.extend({
        className: 'feed-new',

        events: {
            'click': 'handleAddUnread',
        },

        handleAddUnread: function () {
            this.collection.addUnread();
            this.close();
        },

        template: unreadCountTemplate,

        // Overwrite rather than inherit serializeData because it's
        // unneeded extra work to serialize this.collection
        serializeData: function () {
            return {
                numUnread: this.collection.unreadQueue.length,
            };
        },

        render: function () {
            // Don't display "Show 0 New Items"
            if (this.serializeData().numUnread <= 0)
                return this;

            return parentProto.render.call(this);
        },
    });
});

